export default function disableProactivity() {
  const dayOfWeek = new Date().getDay();
  const isWeekendDay = dayOfWeek === 0 || dayOfWeek === 6;
  return isWeekendDay;
}